import { PasswordField } from "@bryntum/schedulerpro";
import { WIDGET_KEYS } from "../../../other/constants/WidgetKeys.jsx";

export class SwivuPasswordField extends PasswordField {
  static get type() {
    return WIDGET_KEYS.fieldPassword;
  }

  static get configurable() {
    return {
      editable: true,
      triggers: {
        password: {
          cls: `b-fa b-fa-eye`,
          handler: "handleVisible"
        }
      }
    };
  }

  handleVisible() {
    if (this.input.type === "text") {
      this.input.type = "password";
      this.triggers.password.cls = "b-fa b-fa-eye";
    } else {
      this.input.type = "text";
      this.triggers.password.cls = "b-fa b-fa-eye-slash";
    }
  }
}

SwivuPasswordField.initClass();
